import React from 'react'

const Team = () => {
    const database = [
        {
            link:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/team/team-1.jpg",
            name:"Walter White"
        },
        {
            link:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/team/team-2.jpg",
            name:"Sarah Jhonson"
        },
        {
            link:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/team/team-3.jpg",
            name:"William Anderson"
        },
        {
            link:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/team/team-4.jpg",
            name:"Amanda Jepson"
        },
    ]
  return (
    <>
      <div className='mainTeam'>
      <div className='serviceText'>
            <h4>Team</h4>
            <h2>Our team is always here to help</h2>
            <div></div>
        </div>
        <div className='teamphoto'>
                {
                    database.map(({link,name},index)=>{
                        return (
                            <div className='member' key={index}>
                    <img src={link} className='image-fluid' alt="ss" />
                    <div className='memberSocial'>
                    <i className="fa fa-facebook"></i>
                    <i className="fa fa-instagram"></i>
                    <i className="fa fa-twitter"></i>
                    <i className="fa fa-linkedin"></i>
                    </div>
                    <div className='memberName'>
                        <h3>{name}</h3>
                    </div>
                </div>
                        )
                    })
                }
                
            </div>
      </div>
    </>
  )
}

export default Team
